import gsap from 'gsap'
import { isThereСlass } from './help-functions'

export default function (callback) {
  if (!sessionStorage.getItem('preloaderShow')) {
    if (isThereСlass('.home-hero-section')) {
      gsap
        .timeline()
        .add(preloaderTl())
        .add(homeHeroTl(), '<3')
        .add(removeOverflowTl(), '<1')
        .call(callback, null, '<')
    } else if (isThereСlass('.hero-section')) {
      gsap
        .timeline()
        .add(preloaderTl())
        .add(heroTl(), '<3')
        .add(removeOverflowTl(), '<')
        .call(callback, null, '<')
    }
    else if (isThereСlass('.news-hero-section')) {
      gsap
        .timeline()
        .add(preloaderTl())
        .add(newsHeroTl(), '<3')
        .add(removeOverflowTl(), '<')
        .call(callback, null, '<')
    } else {
      gsap
        .timeline()
        .add(preloaderTl())
        .add(removeOverflowTl(), '>-2')
        .call(callback, null, '<')
    }
    sessionStorage.setItem('preloaderShow', 1);
  } else {

    if (isThereСlass('.home-hero-section')) {
      gsap
        .timeline()
        .add(withoutPreloader())
        .add(homeHeroTl(), '<')
        .add(removeOverflowTl(), '<1')
        .call(callback, null, '<')
    } else if (isThereСlass('.hero-section')) {
      gsap
        .timeline()
        .add(withoutPreloader())
        .add(heroTl(), '<')
        .add(removeOverflowTl(), '<')
        .call(callback, null, '<')
    }
    else if (isThereСlass('.news-hero-section')) {
      gsap
        .timeline()
        .add(withoutPreloader())
        .add(newsHeroTl(), '<')
        .add(removeOverflowTl(), '<')
        .call(callback, null, '<')
    } else {
      gsap
        .timeline()
        .add(withoutPreloader())
        .add(removeOverflowTl(), '<')
        .call(callback, null, '<')
    }

  }

  function preloaderTl() {
    return gsap
      .timeline({
        defaults: {
          ease: 'customEase',
        },
      })
      .to('.preloader-title', {
        y: '0%',
        duration: 1,
      })

      .to('.preloader-subtitle', {
        y: '0%',
        duration: 1,
      },
        '<0.2'
      )

      .to('.preloader-title', {
        y: '-100%',
        duration: 0.5,
      },
        '>1'
      )

      .to('.preloader-subtitle', {
        y: '100%',
        duration: 0.5,
      },
        '<'
      )

      .to('#preloader', {
        opacity: 0,
        pointerEvents: 'none',
        duration: 3,
      },
        '>0.3'
      )
  }

  function withoutPreloader() {
    return gsap.to('#preloader', {
      opacity: 0,
      pointerEvents: 'none',
      duration: 2,
      overwrite: 'auto',
    })
  }

  function homeHeroTl() {
    return gsap
      .timeline({
        defaults: {
          ease: 'customEase',
        },
      })
      .from('.home-hero-clip-img img', {
        scale: 1.4,
        duration: 3.5,
      },
        '<'
      )

      .call(() => {
        gsap.effects.split('.home-hero-title')
      },
        null,
        '>-2.5'
      )

      .call(() => {
        gsap.effects.animateArrow('.arrow-link')
      },
        null,
        '>1'
      )


    // Now Swiper slider disable in Home Hero Section


    // .from('.home-hero-slider-bg', {
    //   opacity: 0,
    //   duration: 1,
    // },
    //   '<'
    // )

    // .to('.home-hero-slider-clip', {
    //   clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    //   duration: 1.5,
    // },
    //   '<'
    // )

    // .to('.home-hero-img-slider', {
    //   scale: 1,
    //   duration: 1.5,
    // },
    //   '<'
    // )

    // .call(() => {
    //   if (!document.querySelector('.home-hero-content-slider')) return;
    //   document.querySelector('.home-hero-content-slider').classList.add('show')
    // },
    //   null,
    //   '>-1'
    // )

    // .from('.swiper-button-prev svg', {
    //   x: '100%',
    //   duration: 1,
    // },
    //   '<0.4'
    // )

    // .from('.swiper-button-next svg', {
    //   x: '-100%',
    //   duration: 1,
    // },
    //   '<0.2'
    // )
  }

  function heroTl() {
    return gsap
      .timeline({
        defaults: {
          ease: 'customEase',
        },
      })
      .to('.hero-img', {
        opacity: 1,
        scale: 1,
        duration: 3.5,
      })
      .call(
        () => {
          gsap.effects.fade('.hero-uppertitle')
        },
        null,
        '>-2.5'
      )
      .call(
        () => {
          gsap.effects.split('.hero-title')
        },
        null,
        '<0.15'
      )
      .call(
        () => {
          if (isThereСlass('.hero-p')) {
            gsap.effects.fade('.hero-p')
          }
        },
        null,
        '<0.3'
      )
  }

  function newsHeroTl() {
    return gsap
      .timeline({
        defaults: {
          ease: 'basicEase',
        },
      })
      .call(() => {
        gsap.effects.fade('.news-hero-uppertitle')
      }, null)

      .call(() => {
        gsap.effects.split('.news-hero-title')
      }, null, '<0.15')

      .to('.news-hero-img', {
        opacity: 1,
        scale: 1,
        duration: 3,
        ease: 'customEase',
      }, '<0.3')

      .to('.news-hero-content [fade]', {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        duration: 1
      }, '<1')
  }

  function removeOverflowTl() {
    return gsap.timeline().call(() => {
      document.querySelector('html').classList.remove('overflow-hidden')
    })
  }
}
